import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, ToastController } from 'ionic-angular';
import { AuthService } from '../../providers/auth/auth';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

/**
 * Generated class for the PasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-password',
  templateUrl: 'password.html',
})
export class PasswordPage {
  loading: Loading;
  resetPasswordForm: FormGroup;

  constructor(public navCtrl: NavController, public navParams: NavParams, private authService: AuthService, private loadingCtrl: LoadingController, private formBuilder: FormBuilder, private tCtrl: ToastController) {
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])]
    })
  }

  back(){
    this.navCtrl.popToRoot();
  }

  resetPassword() {
    let formValues = this.resetPasswordForm.value;
    this.loading = this.loadingCtrl.create({
    });
    this.loading.present();
    this.authService.resetPassword(formValues.email).then((response) => {
      let toast = this.tCtrl.create({
        message: "E-Mail für Passwortreset wurde gesendet.",
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.loading.dismiss();
    }).catch((error) => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/password/password.ts